import { render, staticRenderFns } from "./TheModalEvolucionMedica.vue?vue&type=template&id=70031216&"
import script from "./TheModalEvolucionMedica.vue?vue&type=script&lang=js&"
export * from "./TheModalEvolucionMedica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports